import { AutogenLayoutMobileCommAlarmHistoryList } from "./autogen/AutogenLayoutMobileCommAlarmHistoryList";

export class MobileCommAlarmHistoryList extends AutogenLayoutMobileCommAlarmHistoryList {
    override onLoad() {
    }
}
